import axios from "axios";

axios.defaults.headers = {
	'Accept': 'application/json',
	'X-CSRF-Token': window.csrfTokenValue,
	'X-Requested-With': 'XMLHttpRequest'
};
export default axios;
